/**
 * Players earlier than 2.1.2.0 require this mixin.
 * @mixin BSLegacyScreenshotMixin
 * @todo write description
 */
var BSLegacyScreenshotMixin = function () {
    var self = this;

    /**
     * @member {null|function} _legacyScreenshotResolve
     * @private
     * @memberOf BSLegacyScreenshotMixin
     * @todo write description
     */
    this._legacyScreenshotResolve = null;

    /**
     * @method _legacyScreenshotListener
     * @param {BrightScriptMessenger.BsMessageEvent} message
     * @memberOf BSLegacyScreenshotMixin
     * @todo write description
     */
    this._legacyScreenshotListener = function (message) {
        try {
            self._legacyScreenshotResolve(message.data);
        } catch (error) {
            console.warn('legacyScreenshot', error);
        }
    };

    /**
     * @method _getLegacyScreenshot
     * @return {Promise.<ScreenshotInterface.ScreenshotPromiseSuccess>}
     * @memberOf BSLegacyScreenshotMixin
     * @todo write description
     */
    this._getLegacyScreenshot = function () {
        return new Promise(function (resolve) {
            self._legacyScreenshotResolve = resolve;
            self._messenger.postMessage('GET_SCREENSHOT');
        }).then(function (screenshotData) {
            self._legacyScreenshotResolve = null;
            return screenshotData;
        });
    };

    this._messenger.addBSMessageListener(
        'screenshotComplete',
        this._legacyScreenshotListener.bind(this)
    );

    return this;
};

export { BSLegacyScreenshotMixin };
